import React, { useState, useMemo, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import {
	FaTrophy,
	FaMedal,
	FaAward,
	FaGraduationCap,
	FaCalendarAlt,
	FaSearch,
	FaStar,
	FaUserGraduate,
	FaBookOpen,
	FaCheckCircle,
} from "react-icons/fa";

// 1. Official list of M.Ed. Toppers
const medToppers = [
	{
		slNo: 1,
		name: "Laxmi Sekhar",
		session: "2009-10",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "80.33%",
		percentageNum: 80.33,
		merit: "1st Position",
	},
	{
		slNo: 2,
		name: "Supriya Kumari",
		session: "2010-11",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "79.50%",
		percentageNum: 79.5,
		merit: "1st Position",
	},
	{
		slNo: 3,
		name: "Mukta Sinha",
		session: "2011-12",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "79.85%",
		percentageNum: 79.85,
		merit: "1st Position",
	},
	{
		slNo: 4,
		name: "Ram Krishna Prasad",
		session: "2012-13",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "78.28%",
		percentageNum: 78.28,
		merit: "1st Position",
	},
	{
		slNo: 5,
		name: "Abha Kumari",
		session: "2013-14",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "85.28%",
		percentageNum: 85.28,
		isAllTimeHighest: true,
		merit: "1st Position",
	},
	{
		slNo: 6,
		name: "Ashison Engren Tirkey",
		session: "2014-15",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "84.85%",
		percentageNum: 84.85,
		merit: "1st Position",
	},
	{
		slNo: 7,
		name: "Priyanka Kumari",
		session: "2015-17",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "80.00%",
		percentageNum: 80.0,
		merit: "1st Position",
	},
	{
		slNo: 8,
		name: "Priya Deo",
		session: "2016-18",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "80.70%",
		percentageNum: 80.7,
		merit: "1st Position",
	},
	{
		slNo: 9,
		name: "Khushnuma Sheyam",
		session: "2017-19",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "83.90%",
		percentageNum: 83.9,
		merit: "1st Position",
	},
	{
		slNo: 10,
		name: "Shahina Naaz",
		session: "2018-20",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "82.55%",
		percentageNum: 82.55,
		merit: "1st Position",
	},
	{
		slNo: 11,
		name: "Jyoti Kumari",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "82.75%",
		percentageNum: 82.75,
		merit: "1st Position",
	},
	{
		slNo: 12,
		name: "Fauzia Khanam",
		session: "2020-22",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "77.60%",
		percentageNum: 77.6,
		merit: "1st Position",
	},
	{
		slNo: 13,
		name: "Smriti Sinha",
		session: "2021-23",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "79.20%",
		percentageNum: 79.2,
		merit: "1st Position",
	},
	{
		slNo: 14,
		name: "Nashra Perween",
		session: "2022-24",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "81.95%",
		percentageNum: 81.95,
		merit: "1st Position",
	},
	{
		slNo: 15,
		name: "Anvita Priyam",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "med",
		percentage: "79.35%",
		percentageNum: 79.35,
		isLatest: true,
		merit: "1st Position",
	},
];

// 2. Official list of 4 Yrs. B.A./B.Sc. B.Ed. Integrated Course Toppers
const integratedToppers = [
	{
		slNo: 1,
		name: "Kalpana Kumari",
		session: "2018-22",
		course: "4 Yrs. B.A./B.Sc. B.Ed.",
		courseCategory: "integrated",
		percentage: "79.98%",
		percentageNum: 79.98,
		merit: "1st Position",
	},
	{
		slNo: 2,
		name: "Uma Kumari",
		session: "2019-23",
		course: "4 Yrs. B.A./B.Sc. B.Ed.",
		courseCategory: "integrated",
		percentage: "79.11%",
		percentageNum: 79.11,
		merit: "1st Position",
	},
	{
		slNo: 3,
		name: "Kriti Kumari",
		session: "2020-24",
		course: "4 Yrs. B.A./B.Sc. B.Ed.",
		courseCategory: "integrated",
		percentage: "80.77%",
		percentageNum: 80.77,
		merit: "1st Position",
	},
	{
		slNo: 4,
		name: "Khushboo Kumari",
		session: "2021-25",
		course: "4 Yrs. B.A./B.Sc. B.Ed.",
		courseCategory: "integrated",
		percentage: "81.41%",
		percentageNum: 81.41,
		isAllTimeHighest: true,
		isLatest: true,
		merit: "1st Position",
	},
];

// 3. Official list of Students who Qualified NET/JRF during the last five years
const netJrfStudents = [
	{
		slNo: 1,
		name: "Shamsher Alam",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 2,
		name: "Prabhat Kumar Ravi",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 3,
		name: "Anshu Bala",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 4,
		name: "Deepak Bharti",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 5,
		name: "Sanjeet Kumar Das",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 6,
		name: "Jyoti Kumari",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 7,
		name: "Divya Dubey",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 8,
		name: "Jaya Jha",
		session: "2019-21",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 9,
		name: "Manila Manisha Kandulna",
		session: "2020-22",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 10,
		name: "Dharmendra Trivedi",
		session: "2020-22",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 11,
		name: "Sharad Kumar",
		session: "2020-22",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 12,
		name: "Sanchana Srivastava",
		session: "2020-22",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 13,
		name: "Fauzia Khanam",
		session: "2021-23",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 14,
		name: "Arpit Tuti",
		session: "2021-23",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 15,
		name: "Garima Gupta",
		session: "2021-23",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 16,
		name: "Dev Kumar Saw",
		session: "2021-23",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 17,
		name: "Krishna Kumar Yadav",
		session: "2022-24",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 18,
		name: "Aditi Surin",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 19,
		name: "Anvita Priyam",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 20,
		name: "Renuka Tudu",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 21,
		name: "Rahul Kumar Pandey",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 22,
		name: "Preeti Kumari",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
	{
		slNo: 23,
		name: "Pradeep Kumar Ravi",
		session: "2023-25",
		course: "M.Ed.",
		courseCategory: "netjrf",
		achievement: "UGC NET / JRF",
		merit: "NET / JRF Qualified",
	},
];

// All combined records
const allRecords = [...medToppers, ...integratedToppers, ...netJrfStudents];

function Toppers({ defaultTab }) {
	const location = useLocation();

	// Support defaultTab prop or URL query param ?type=netjrf
	const initialTab = useMemo(() => {
		if (defaultTab) return defaultTab;
		if (location.pathname === "/net-jrf") return "netjrf";
		return "all";
	}, [defaultTab, location.pathname]);

	const [activeProgramme, setActiveProgramme] = useState(initialTab);
	const [selectedSession, setSelectedSession] = useState("All Sessions");
	const [searchQuery, setSearchQuery] = useState("");

	useEffect(() => {
		if (location.pathname === "/net-jrf") {
			setActiveProgramme("netjrf");
			setSelectedSession("All Sessions");
		}
	}, [location.pathname]);

	// Filter list based on selected tab / programme
	const programmeRecords = useMemo(() => {
		if (activeProgramme === "med") return medToppers;
		if (activeProgramme === "integrated") return integratedToppers;
		if (activeProgramme === "netjrf") return netJrfStudents;
		return allRecords;
	}, [activeProgramme]);

	// Available sessions dynamically computed for current programme
	const availableSessions = useMemo(() => {
		const uniqueSessions = Array.from(
			new Set(programmeRecords.map((item) => item.session))
		);
		// Sort sessions descending
		uniqueSessions.sort((a, b) => b.localeCompare(a));
		return ["All Sessions", ...uniqueSessions];
	}, [programmeRecords]);

	const handleProgrammeChange = (prog) => {
		setActiveProgramme(prog);
		setSelectedSession("All Sessions");
	};

	// Final filtered records based on session dropdown & search query
	const filteredRecords = useMemo(() => {
		return programmeRecords.filter((item) => {
			const matchesSession =
				selectedSession === "All Sessions" || item.session === selectedSession;
			const matchesSearch =
				searchQuery.trim() === "" ||
				item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
				item.session.toLowerCase().includes(searchQuery.toLowerCase()) ||
				item.course.toLowerCase().includes(searchQuery.toLowerCase()) ||
				(item.percentage && item.percentage.includes(searchQuery)) ||
				(item.achievement && item.achievement.toLowerCase().includes(searchQuery.toLowerCase()));
			return matchesSession && matchesSearch;
		});
	}, [programmeRecords, selectedSession, searchQuery]);

	// Single spotlight card when exactly 1 topper record is displayed
	const selectedTopper =
		selectedSession !== "All Sessions" && filteredRecords.length === 1
			? filteredRecords[0]
			: null;

	// Stats computation
	const highestScore = useMemo(() => {
		const withScore = programmeRecords.filter((item) => item.percentageNum);
		if (withScore.length === 0) return null;
		return [...withScore].sort((a, b) => b.percentageNum - a.percentageNum)[0];
	}, [programmeRecords]);

	const latestRecord = useMemo(() => {
		if (programmeRecords.length === 0) return null;
		return [...programmeRecords].sort((a, b) =>
			b.session.localeCompare(a.session)
		)[0];
	}, [programmeRecords]);

	return (
		<>
			<Helmet>
				<title>
					{activeProgramme === "netjrf"
						? "NET / JRF Qualified Students | University Department of Education"
						: "Department Toppers & Merit Lists | University Department of Education"}
				</title>
				<meta
					name="description"
					content="Session-wise Toppers and NET/JRF Qualified Students of University Department of Education, Vinoba Bhave University, Hazaribag."
				/>
			</Helmet>

			<div className="PageContainer">
				{/* Header Banner */}
				<div className="AdmissionHeader HeaderImg">
					<img
						src="/Images/Banner/AdmissionProcess.png"
						alt="toppers-banner"
					/>
				</div>

				{/* Page Heading */}
				<div id="Heading" data-aos="fade-up">
					<h1>
						{activeProgramme === "netjrf"
							? "Students Qualified NET / JRF"
							: "Department Toppers & Merit Lists"}
					</h1>
				</div>

				<div
					className="ToppersDepartmentBanner"
					data-aos="fade-up"
					style={{
						textAlign: "center",
						marginBottom: "30px",
						padding: "0 15px",
					}}
				>
					<h3
						style={{
							fontSize: "20px",
							color: "#1e3a5f",
							fontWeight: "700",
							marginBottom: "6px",
						}}
					>
						University Department of Education
					</h3>
					<p
						style={{
							fontSize: "15px",
							color: "#475569",
							maxWidth: "700px",
							margin: "0 auto",
						}}
					>
						Vinoba Bhave University, Hazaribag - 825301 (Jharkhand)
					</p>
					<div
						style={{
							display: "inline-flex",
							alignItems: "center",
							gap: "8px",
							marginTop: "12px",
							padding: "6px 18px",
							backgroundColor: "rgba(214, 158, 46, 0.12)",
							border: "1px solid rgba(214, 158, 46, 0.35)",
							borderRadius: "20px",
							color: "#b7791f",
							fontSize: "13px",
							fontWeight: "600",
						}}
					>
						<FaAward /> Official Certified Academic Record • Ref. No. VBU/M.Ed.
					</div>
				</div>

				{/* Programme Selector Tabs */}
				<div
					className="ProgrammeTabs"
					data-aos="fade-up"
					style={{
						maxWidth: "1050px",
						margin: "0 auto 30px auto",
						padding: "0 15px",
						display: "flex",
						flexWrap: "wrap",
						gap: "10px",
						justifyContent: "center",
					}}
				>
					<button
						onClick={() => handleProgrammeChange("all")}
						style={{
							cursor: "pointer",
							padding: "10px 20px",
							borderRadius: "30px",
							fontWeight: "700",
							fontSize: "14px",
							display: "inline-flex",
							alignItems: "center",
							gap: "8px",
							border: activeProgramme === "all" ? "2px solid #0038A3" : "2px solid #e2e8f0",
							backgroundColor: activeProgramme === "all" ? "#0038A3" : "#ffffff",
							color: activeProgramme === "all" ? "#ffffff" : "#475569",
							boxShadow:
								activeProgramme === "all"
									? "0 4px 12px rgba(0, 56, 163, 0.25)"
									: "0 2px 6px rgba(0, 0, 0, 0.04)",
							transition: "all 0.2s ease-in-out",
						}}
					>
						<FaGraduationCap /> All Records ({allRecords.length})
					</button>

					<button
						onClick={() => handleProgrammeChange("med")}
						style={{
							cursor: "pointer",
							padding: "10px 20px",
							borderRadius: "30px",
							fontWeight: "700",
							fontSize: "14px",
							display: "inline-flex",
							alignItems: "center",
							gap: "8px",
							border: activeProgramme === "med" ? "2px solid #0038A3" : "2px solid #e2e8f0",
							backgroundColor: activeProgramme === "med" ? "#0038A3" : "#ffffff",
							color: activeProgramme === "med" ? "#ffffff" : "#475569",
							boxShadow:
								activeProgramme === "med"
									? "0 4px 12px rgba(0, 56, 163, 0.25)"
									: "0 2px 6px rgba(0, 0, 0, 0.04)",
							transition: "all 0.2s ease-in-out",
						}}
					>
						<FaBookOpen /> M.Ed. Toppers ({medToppers.length})
					</button>

					<button
						onClick={() => handleProgrammeChange("integrated")}
						style={{
							cursor: "pointer",
							padding: "10px 20px",
							borderRadius: "30px",
							fontWeight: "700",
							fontSize: "14px",
							display: "inline-flex",
							alignItems: "center",
							gap: "8px",
							border: activeProgramme === "integrated" ? "2px solid #0038A3" : "2px solid #e2e8f0",
							backgroundColor: activeProgramme === "integrated" ? "#0038A3" : "#ffffff",
							color: activeProgramme === "integrated" ? "#ffffff" : "#475569",
							boxShadow:
								activeProgramme === "integrated"
									? "0 4px 12px rgba(0, 56, 163, 0.25)"
									: "0 2px 6px rgba(0, 0, 0, 0.04)",
							transition: "all 0.2s ease-in-out",
						}}
					>
						<FaStar /> 4 Yrs. Integrated ({integratedToppers.length})
					</button>

					<button
						onClick={() => handleProgrammeChange("netjrf")}
						style={{
							cursor: "pointer",
							padding: "10px 20px",
							borderRadius: "30px",
							fontWeight: "700",
							fontSize: "14px",
							display: "inline-flex",
							alignItems: "center",
							gap: "8px",
							border: activeProgramme === "netjrf" ? "2px solid #059669" : "2px solid #e2e8f0",
							backgroundColor: activeProgramme === "netjrf" ? "#059669" : "#ffffff",
							color: activeProgramme === "netjrf" ? "#ffffff" : "#475569",
							boxShadow:
								activeProgramme === "netjrf"
									? "0 4px 12px rgba(5, 150, 105, 0.25)"
									: "0 2px 6px rgba(0, 0, 0, 0.04)",
							transition: "all 0.2s ease-in-out",
						}}
					>
						<FaCheckCircle /> NET / JRF Qualified ({netJrfStudents.length})
					</button>
				</div>

				{/* Quick Stats Highlights */}
				<div
					className="ToppersStatsGrid"
					data-aos="fade-up"
					style={{
						display: "grid",
						gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
						gap: "20px",
						maxWidth: "1050px",
						margin: "0 auto 30px auto",
						padding: "0 15px",
					}}
				>
					<div
						style={{
							background: "linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)",
							color: "#fff",
							padding: "22px 20px",
							borderRadius: "12px",
							boxShadow: "0 4px 15px rgba(30, 58, 95, 0.15)",
							display: "flex",
							alignItems: "center",
							gap: "16px",
						}}
					>
						<div
							style={{
								width: "50px",
								height: "50px",
								borderRadius: "10px",
								backgroundColor: "rgba(255, 255, 255, 0.15)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "24px",
								flexShrink: 0,
							}}
						>
							<FaGraduationCap />
						</div>
						<div>
							<div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.85 }}>
								Total Students Listed
							</div>
							<div style={{ fontSize: "24px", fontWeight: "700", marginTop: "2px" }}>
								{programmeRecords.length} Students
							</div>
							<div style={{ fontSize: "12px", opacity: 0.75 }}>
								{activeProgramme === "med"
									? "M.Ed. Toppers (15 Sessions)"
									: activeProgramme === "integrated"
									? "Integrated B.Ed. (4 Batches)"
									: activeProgramme === "netjrf"
									? "Qualified NET/JRF (Last 5 Years)"
									: "Toppers & Qualified Scholars"}
							</div>
						</div>
					</div>

					<div
						style={{
							background:
								activeProgramme === "netjrf"
									? "linear-gradient(135deg, #059669 0%, #10b981 100%)"
									: "linear-gradient(135deg, #b7791f 0%, #d69e2e 100%)",
							color: "#fff",
							padding: "22px 20px",
							borderRadius: "12px",
							boxShadow: "0 4px 15px rgba(214, 158, 46, 0.25)",
							display: "flex",
							alignItems: "center",
							gap: "16px",
						}}
					>
						<div
							style={{
								width: "50px",
								height: "50px",
								borderRadius: "10px",
								backgroundColor: "rgba(255, 255, 255, 0.2)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "24px",
								flexShrink: 0,
							}}
						>
							{activeProgramme === "netjrf" ? <FaCheckCircle /> : <FaTrophy />}
						</div>
						<div>
							<div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.9 }}>
								{activeProgramme === "netjrf" ? "Examination" : "Highest Score Record"}
							</div>
							<div style={{ fontSize: "24px", fontWeight: "700", marginTop: "2px" }}>
								{activeProgramme === "netjrf"
									? "UGC NET / JRF"
									: highestScore
									? highestScore.percentage
									: "-"}
							</div>
							<div style={{ fontSize: "12px", opacity: 0.9 }}>
								{activeProgramme === "netjrf"
									? "National Eligibility Test"
									: highestScore
									? `${highestScore.name} (${highestScore.session})`
									: "-"}
							</div>
						</div>
					</div>

					<div
						style={{
							background: "linear-gradient(135deg, #0f766e 0%, #0d9488 100%)",
							color: "#fff",
							padding: "22px 20px",
							borderRadius: "12px",
							boxShadow: "0 4px 15px rgba(13, 148, 136, 0.2)",
							display: "flex",
							alignItems: "center",
							gap: "16px",
						}}
					>
						<div
							style={{
								width: "50px",
								height: "50px",
								borderRadius: "10px",
								backgroundColor: "rgba(255, 255, 255, 0.2)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "24px",
								flexShrink: 0,
							}}
						>
							<FaMedal />
						</div>
						<div>
							<div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.9 }}>
								Most Recent Session
							</div>
							<div style={{ fontSize: "24px", fontWeight: "700", marginTop: "2px" }}>
								{latestRecord ? `Session ${latestRecord.session}` : "-"}
							</div>
							<div style={{ fontSize: "12px", opacity: 0.9 }}>
								{latestRecord ? `${latestRecord.name}` : "-"}
							</div>
						</div>
					</div>
				</div>

				{/* Filter & Dropdown Section */}
				<div
					className="ToppersFilterSection"
					data-aos="fade-up"
					style={{
						maxWidth: "1050px",
						margin: "0 auto 30px auto",
						padding: "20px 24px",
						backgroundColor: "#ffffff",
						borderRadius: "12px",
						border: "1px solid #e2e8f0",
						boxShadow: "0 4px 12px rgba(0, 0, 0, 0.04)",
					}}
				>
					<div
						style={{
							display: "flex",
							flexWrap: "wrap",
							gap: "20px",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						{/* Session Dropdown */}
						<div style={{ flex: "1 1 280px", minWidth: "260px" }}>
							<label
								htmlFor="session-select"
								style={{
									display: "block",
									fontSize: "14px",
									fontWeight: "600",
									color: "#1e293b",
									marginBottom: "8px",
								}}
							>
								<FaCalendarAlt style={{ marginRight: "6px", color: "#0038A3" }} />
								Select Academic Session:
							</label>
							<div style={{ position: "relative" }}>
								<select
									id="session-select"
									value={selectedSession}
									onChange={(e) => setSelectedSession(e.target.value)}
									style={{
										width: "100%",
										padding: "12px 16px",
										fontSize: "15px",
										fontWeight: "500",
										color: "#1e293b",
										backgroundColor: "#f8fafc",
										border: "2px solid #cbd5e1",
										borderRadius: "8px",
										cursor: "pointer",
										outline: "none",
										transition: "border-color 0.2s, box-shadow 0.2s",
									}}
									onFocus={(e) => (e.target.style.borderColor = "#0038A3")}
									onBlur={(e) => (e.target.style.borderColor = "#cbd5e1")}
								>
									{availableSessions.map((session) => (
										<option key={session} value={session}>
											{session === "All Sessions"
												? "🎓 All Sessions"
												: `Session ${session}`}
										</option>
									))}
								</select>
							</div>
						</div>

						{/* Search Box */}
						<div style={{ flex: "1 1 240px", minWidth: "220px" }}>
							<label
								htmlFor="search-topper"
								style={{
									display: "block",
									fontSize: "14px",
									fontWeight: "600",
									color: "#1e293b",
									marginBottom: "8px",
								}}
							>
								<FaSearch style={{ marginRight: "6px", color: "#0038A3" }} />
								Search Student / Session:
							</label>
							<input
								id="search-topper"
								type="text"
								placeholder="e.g. Shamsher, Anvita, Kalpana..."
								value={searchQuery}
								onChange={(e) => setSearchQuery(e.target.value)}
								style={{
									width: "100%",
									boxSizing: "border-box",
									padding: "12px 16px",
									fontSize: "15px",
									color: "#1e293b",
									backgroundColor: "#f8fafc",
									border: "2px solid #cbd5e1",
									borderRadius: "8px",
									outline: "none",
								}}
								onFocus={(e) => (e.target.style.borderColor = "#0038A3")}
								onBlur={(e) => (e.target.style.borderColor = "#cbd5e1")}
							/>
						</div>

						{/* Reset Button */}
						{(selectedSession !== "All Sessions" || searchQuery !== "" || activeProgramme !== "all") && (
							<div style={{ display: "flex", alignItems: "flex-end" }}>
								<button
									onClick={() => {
										setActiveProgramme("all");
										setSelectedSession("All Sessions");
										setSearchQuery("");
									}}
									style={{
										padding: "12px 20px",
										backgroundColor: "#f1f5f9",
										color: "#475569",
										border: "1px solid #cbd5e1",
										borderRadius: "8px",
										fontWeight: "600",
										fontSize: "14px",
										cursor: "pointer",
										transition: "all 0.2s",
									}}
									onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e2e8f0")}
									onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#f1f5f9")}
								>
									Reset All Filters
								</button>
							</div>
						)}
					</div>

					{/* Result count */}
					<div
						style={{
							marginTop: "15px",
							paddingTop: "12px",
							borderTop: "1px solid #f1f5f9",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							fontSize: "13px",
							color: "#64748b",
						}}
					>
						<span>
							Showing <b>{filteredRecords.length}</b> of <b>{programmeRecords.length}</b> records
						</span>
						{selectedSession !== "All Sessions" && (
							<span
								style={{
									backgroundColor: "#e0f2fe",
									color: "#0369a1",
									padding: "3px 10px",
									borderRadius: "12px",
									fontWeight: "600",
									fontSize: "12px",
								}}
							>
								Filter: Session {selectedSession}
							</span>
						)}
					</div>
				</div>

				{/* Single Session Spotlight Feature Card */}
				{selectedTopper && (
					<div
						data-aos="fade-up"
						style={{
							maxWidth: "1050px",
							margin: "0 auto 35px auto",
							padding: "0 15px",
						}}
					>
						<div
							style={{
								background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
								border:
									selectedTopper.courseCategory === "netjrf"
										? "2px solid #059669"
										: "2px solid #d69e2e",
								borderRadius: "14px",
								padding: "26px 28px",
								boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
								display: "flex",
								flexWrap: "wrap",
								alignItems: "center",
								justifyContent: "space-between",
								gap: "20px",
							}}
						>
							<div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
								<div
									style={{
										width: "68px",
										height: "68px",
										borderRadius: "50%",
										background:
											selectedTopper.courseCategory === "netjrf"
												? "linear-gradient(135deg, #059669 0%, #10b981 100%)"
												: "linear-gradient(135deg, #d69e2e 0%, #ecc94b 100%)",
										color: "#ffffff",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: "32px",
										boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
										flexShrink: 0,
									}}
								>
									{selectedTopper.courseCategory === "netjrf" ? (
										<FaCheckCircle />
									) : (
										<FaTrophy />
									)}
								</div>
								<div>
									<div
										style={{
											display: "inline-flex",
											alignItems: "center",
											gap: "6px",
											backgroundColor:
												selectedTopper.courseCategory === "netjrf"
													? "#d1fae5"
													: "#fef3c7",
											color:
												selectedTopper.courseCategory === "netjrf"
													? "#065f46"
													: "#b45309",
											padding: "3px 12px",
											borderRadius: "14px",
											fontSize: "12px",
											fontWeight: "700",
											marginBottom: "6px",
										}}
									>
										<FaStar /> {selectedTopper.merit} • Session {selectedTopper.session}
									</div>
									<h2
										style={{
											fontSize: "24px",
											fontWeight: "700",
											color: "#0f172a",
											margin: "0 0 4px 0",
										}}
									>
										{selectedTopper.name}
									</h2>
									<p style={{ margin: 0, color: "#475569", fontSize: "14px" }}>
										Programme: <b>{selectedTopper.course}</b> • Serial No. {selectedTopper.slNo}
									</p>
								</div>
							</div>

							<div
								style={{
									backgroundColor: "#ffffff",
									border: "1px solid #e2e8f0",
									borderRadius: "10px",
									padding: "16px 28px",
									textAlign: "center",
									boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
								}}
							>
								<div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>
									{selectedTopper.percentage ? "Score / Percentage" : "Achievement"}
								</div>
								<div
									style={{
										fontSize: selectedTopper.percentage ? "32px" : "22px",
										fontWeight: "800",
										color:
											selectedTopper.courseCategory === "netjrf"
												? "#059669"
												: "#0038A3",
										marginTop: "2px",
									}}
								>
									{selectedTopper.percentage || selectedTopper.achievement}
								</div>
								{selectedTopper.isAllTimeHighest && (
									<div
										style={{
											fontSize: "11px",
											color: "#b45309",
											fontWeight: "700",
											marginTop: "4px",
										}}
									>
										🌟 All-Time Record
									</div>
								)}
							</div>
						</div>
					</div>
				)}

				{/* Table Container */}
				<div
					className="ToppersTableContainer"
					data-aos="fade-up"
					style={{
						maxWidth: "1050px",
						margin: "0 auto 40px auto",
						padding: "0 15px",
					}}
				>
					<div
						style={{
							backgroundColor: "#ffffff",
							border: "1px solid #e2e8f0",
							borderRadius: "12px",
							overflow: "hidden",
							boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
						}}
					>
						<div
							style={{
								padding: "18px 24px",
								backgroundColor:
									activeProgramme === "netjrf" ? "#059669" : "#0038A3",
								color: "#ffffff",
								display: "flex",
								flexWrap: "wrap",
								justifyContent: "space-between",
								alignItems: "center",
								gap: "10px",
							}}
						>
							<div>
								<h3 style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#ffffff" }}>
									{activeProgramme === "med"
										? "List of Topper's M.Ed. Student"
										: activeProgramme === "integrated"
										? "List of Topper's 4 Yrs. B.A./B.Sc. B.Ed. Integrated Course"
										: activeProgramme === "netjrf"
										? "List of Students who Qualified NET/JRF during the last five years"
										: "Session-wise Department Toppers & Merit Scholars"}
								</h3>
								<p style={{ margin: "4px 0 0 0", fontSize: "13px", opacity: 0.85, color: "#ffffff" }}>
									Official academic certified list from University Department of Education, VBU
								</p>
							</div>
							<div
								style={{
									backgroundColor: "rgba(255, 255, 255, 0.15)",
									padding: "4px 12px",
									borderRadius: "12px",
									fontSize: "12px",
									fontWeight: "600",
								}}
							>
								{filteredRecords.length} Record{filteredRecords.length !== 1 ? "s" : ""}
							</div>
						</div>

						{/* Responsive Table Wrapper */}
						<div style={{ overflowX: "auto", width: "100%" }}>
							<table
								style={{
									width: "100%",
									borderCollapse: "collapse",
									textAlign: "left",
									fontSize: "14px",
								}}
							>
								<thead>
									<tr
										style={{
											backgroundColor: "#f1f5f9",
											borderBottom: "2px solid #cbd5e1",
											color: "#1e293b",
											fontWeight: "700",
										}}
									>
										<th style={{ padding: "14px 18px", width: "70px", textAlign: "center" }}>
											Sl. No.
										</th>
										<th style={{ padding: "14px 18px" }}>Name of Student</th>
										<th style={{ padding: "14px 18px", textAlign: "center" }}>Programme</th>
										<th style={{ padding: "14px 18px", textAlign: "center" }}>Session</th>
										<th style={{ padding: "14px 18px", textAlign: "center" }}>
											{activeProgramme === "netjrf" ? "Examination" : "Percentage"}
										</th>
									</tr>
								</thead>
								<tbody>
									{filteredRecords.length > 0 ? (
										filteredRecords.map((item, index) => {
											const isHighest = item.isAllTimeHighest;
											const isLatest = item.isLatest;
											const isNetJrf = item.courseCategory === "netjrf";

											return (
												<tr
													key={`${item.courseCategory}_${item.slNo}_${item.session}_${item.name}`}
													style={{
														borderBottom: "1px solid #e2e8f0",
														backgroundColor:
															index % 2 === 0 ? "#ffffff" : "#f8fafc",
														transition: "background-color 0.15s ease",
													}}
													onMouseOver={(e) => {
														e.currentTarget.style.backgroundColor = "#f0f7ff";
													}}
													onMouseOut={(e) => {
														e.currentTarget.style.backgroundColor =
															index % 2 === 0 ? "#ffffff" : "#f8fafc";
													}}
												>
													<td
														style={{
															padding: "14px 18px",
															textAlign: "center",
															fontWeight: "600",
															color: "#64748b",
														}}
													>
														{item.slNo}
													</td>
													<td style={{ padding: "14px 18px" }}>
														<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
															<div
																style={{
																	width: "32px",
																	height: "32px",
																	borderRadius: "50%",
																	backgroundColor: isNetJrf
																		? "#d1fae5"
																		: isHighest
																		? "#fef3c7"
																		: isLatest
																		? "#ccfbf1"
																		: "#e0f2fe",
																	color: isNetJrf
																		? "#059669"
																		: isHighest
																		? "#b45309"
																		: isLatest
																		? "#0d9488"
																		: "#0038A3",
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "center",
																	fontSize: "14px",
																	flexShrink: 0,
																}}
															>
																{isNetJrf ? <FaCheckCircle /> : <FaUserGraduate />}
															</div>
															<div>
																<div
																	style={{
																		fontWeight: "700",
																		color: "#0f172a",
																		fontSize: "15px",
																	}}
																>
																	{item.name}
																</div>
																{isHighest && (
																	<span
																		style={{
																			fontSize: "11px",
																			fontWeight: "700",
																			color: "#b45309",
																			display: "inline-flex",
																			alignItems: "center",
																			gap: "4px",
																		}}
																	>
																		<FaStar /> Highest Recorded Marks
																	</span>
																)}
																{isLatest && !isNetJrf && (
																	<span
																		style={{
																			fontSize: "11px",
																			fontWeight: "700",
																			color: "#0d9488",
																			display: "inline-flex",
																			alignItems: "center",
																			gap: "4px",
																		}}
																	>
																		🌟 Most Recent Batch
																	</span>
																)}
															</div>
														</div>
													</td>
													<td style={{ padding: "14px 18px", textAlign: "center" }}>
														<span
															style={{
																display: "inline-block",
																padding: "4px 10px",
																borderRadius: "6px",
																fontSize: "12px",
																fontWeight: "600",
																backgroundColor:
																	item.courseCategory === "med"
																		? "rgba(0, 56, 163, 0.08)"
																		: item.courseCategory === "integrated"
																		? "rgba(180, 83, 9, 0.08)"
																		: "rgba(5, 150, 105, 0.08)",
																color:
																	item.courseCategory === "med"
																		? "#0038A3"
																		: item.courseCategory === "integrated"
																		? "#b45309"
																		: "#059669",
																border:
																	item.courseCategory === "med"
																		? "1px solid rgba(0, 56, 163, 0.2)"
																		: item.courseCategory === "integrated"
																		? "1px solid rgba(180, 83, 9, 0.2)"
																		: "1px solid rgba(5, 150, 105, 0.2)",
															}}
														>
															{item.course}
														</span>
													</td>
													<td style={{ padding: "14px 18px", textAlign: "center" }}>
														<span
															style={{
																display: "inline-flex",
																alignItems: "center",
																gap: "6px",
																padding: "5px 12px",
																borderRadius: "16px",
																backgroundColor: "#f1f5f9",
																color: "#334155",
																fontWeight: "600",
																fontSize: "13px",
																border: "1px solid #cbd5e1",
															}}
														>
															<FaCalendarAlt style={{ fontSize: "11px", color: "#64748b" }} />
															{item.session}
														</span>
													</td>
													<td style={{ padding: "14px 18px", textAlign: "center" }}>
														{item.percentage ? (
															<span
																style={{
																	display: "inline-block",
																	padding: "5px 14px",
																	borderRadius: "16px",
																	fontWeight: "700",
																	fontSize: "14px",
																	backgroundColor:
																		item.percentageNum >= 83
																			? "#dcfce7"
																			: item.percentageNum >= 80
																			? "#e0f2fe"
																			: "#fef9c3",
																	color:
																		item.percentageNum >= 83
																			? "#15803d"
																			: item.percentageNum >= 80
																			? "#0369a1"
																			: "#854d0e",
																	border:
																		item.percentageNum >= 83
																			? "1px solid #86efac"
																			: item.percentageNum >= 80
																			? "1px solid #7dd3fc"
																			: "1px solid #fde047",
																}}
															>
																{item.percentage}
															</span>
														) : (
															<span
																style={{
																	display: "inline-flex",
																	alignItems: "center",
																	gap: "5px",
																	padding: "5px 12px",
																	borderRadius: "16px",
																	fontWeight: "700",
																	fontSize: "13px",
																	backgroundColor: "#d1fae5",
																	color: "#065f46",
																	border: "1px solid #6ee7b7",
																}}
															>
																<FaCheckCircle style={{ color: "#059669" }} />
																{item.achievement}
															</span>
														)}
													</td>
												</tr>
											);
										})
									) : (
										<tr>
											<td
												colSpan="5"
												style={{
													padding: "40px 20px",
													textAlign: "center",
													color: "#64748b",
												}}
											>
												<div style={{ fontSize: "36px", marginBottom: "10px" }}>🔍</div>
												<div style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>
													No student records found
												</div>
												<p style={{ marginTop: "4px", fontSize: "14px" }}>
													Try choosing a different session or clearing your search.
												</p>
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>

						{/* Footer note matching university letterhead */}
						<div
							style={{
								padding: "16px 24px",
								backgroundColor: "#f8fafc",
								borderTop: "1px solid #e2e8f0",
								fontSize: "13px",
								color: "#64748b",
								display: "flex",
								flexWrap: "wrap",
								justifyContent: "space-between",
								alignItems: "center",
								gap: "10px",
							}}
						>
							<div>
								Official source: <b>University Department of Education, VBU Hazaribag</b>
							</div>
							<div>
								Ref. No: <b>VBU/M.Ed.</b>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Toppers;
